exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title{\r\n    padding: 45px;\r\n    padding-left: 1px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/about/terms-of-use/terms-of-use.component.css
// module id = 603
// module chunks = 8